import { Navigate } from "react-router";
import { usePermissions } from "@/hooks/auth/use-permissions";

interface ProtectedRouteProps {
  requireAdmin?: boolean;
  redirectTo?: string;
  children: React.ReactNode;
}

export function ProtectedRoute({
  requireAdmin,
  redirectTo = "/settings/user",
  children,
}: ProtectedRouteProps) {
  const { isAdmin } = usePermissions();

  if (requireAdmin && !isAdmin) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
